
import * as angular from "angular";
import { FoundationUserService } from "@foundation/_services/user.service.ajs";
import { UsersService } from "@services/users.service";

export interface IUserEmailScope extends angular.IScope {
    userEmail: IUserEmailChange;
}

interface IUserEmailChange {
    originalUserEmail: string;
    customerId: number;
}

export class UserEmailDirective implements angular.IDirective {

    restrict = 'A';
    require = 'ngModel';
    scope = { userEmail: "<?" }

    static $inject = ['$q', '$window', 'usersService','foundationUserService'];

    constructor(
        private $q: angular.IQService,
        private $window: angular.IWindowService,
        private usersService: UsersService,
        private foundationUserService: FoundationUserService) {
    }

    link(scope: IUserEmailScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        ngModel.$asyncValidators["userEmail"] = (formValue: string) => {
            if (!formValue) {
                return this.$q.resolve();
            }

            if (scope.userEmail.originalUserEmail?.toLowerCase() == formValue.toLowerCase()) {
                return this.$q.resolve();
            }
            return this.usersService.emailBelongsToAccount(formValue, scope.userEmail.customerId).then(result => {
                if (result) {
                    return this.$q.reject("Email address is already in use.");
                }

                return this.$q.resolve();
            });
        };
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($q: angular.IQService, $window: angular.IWindowService, usersService: UsersService, foundationUserService: FoundationUserService) => new UserEmailDirective($q, $window, usersService, foundationUserService);
        directive.$inject = ['$q', '$window', 'usersService', 'foundationUserService'];
        return directive;
    }

}
